import { render, staticRenderFns } from "./IncidentReportSidebar.vue?vue&type=template&id=36198a53&scoped=true&"
import script from "./IncidentReportSidebar.vue?vue&type=script&lang=js&"
export * from "./IncidentReportSidebar.vue?vue&type=script&lang=js&"
import style0 from "./IncidentReportSidebar.vue?vue&type=style&index=0&id=36198a53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36198a53",
  null
  
)

export default component.exports